import { lighten as curriedLighten } from '../../node_modules/polished/dist/polished.esm.js';
import styled, { keyframes, css } from 'styled-components';
import { marginStyles, paddingStyles } from '../../styles/components.js';

const gradientAnimation = keyframes `
  100% {
    transform: translateX(100%);
  }
`;
const getShimmerValue = (props) => curriedLighten(0.05, props.theme.colors.background[props.backgroundColor]);
const afterStyles = (props) => {
    if (props.withShimmer) {
        return css `
      animation-name: ${gradientAnimation};
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
    `;
    }
    else if (props.withShimmer === false) {
        return css `
      animation: none;
    `;
    }
};
const StyledSkeleton = styled.div `
  ${props => marginStyles(props.margin)}
  ${props => paddingStyles(props.padding)}

  background: ${props => props.theme.colors.background[props.backgroundColor]};
  border-radius: ${props => props.theme.borderRadii[props.borderRadius]};
  height: ${props => props.height};
  max-height: ${props => props.maxHeight};
  max-width: ${props => props.maxWidth};
  opacity: ${props => props.theme.opacities[props.opacity]};
  overflow: hidden;
  position: relative;
  width: ${props => props.width};

  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      transparent,
      ${getShimmerValue},
      transparent
    );

    ${afterStyles}
  }
`;

export { StyledSkeleton as default };
